import type { ColumnSubType } from './column.types'

export const MATCH_MODES = [
  'equals',
  'not_equals',
  'in',
  'not_in',
  'contains',
  'not_contains',
  'starts_with',
  'ends_with',
  'greater_than',
  'greater_than_or_equal_to',
  'less_than',
  'less_than_or_equal_to',
  'between',
  'regex',
  'not_regex',
  'is_empty',
  'is_not_empty',
] as const

export type FilterMatchMode = (typeof MATCH_MODES)[number]

export type FilterDropdownableValue = string | number

/** Distinct-value metadata shared by controller facets and values derived from local rows. */
export interface FilterDropdownable {
  readonly unique_count: number
  readonly values?: readonly FilterDropdownableValue[]
}

export type FilterDropdownables = Readonly<Record<string, FilterDropdownable>>

/** Controller filter descriptor owned by module 08 (contract 08 section 5). */
export interface ReportFilter {
  field: string
  match_mode: FilterMatchMode
  value: unknown
  is_change?: boolean
  direction?: 'increase' | 'decrease'
  sub_type?: ColumnSubType
}

/** UI-safe saved-filter identity; the service maps it to/from the legacy flat wire shape. */
export interface SavedReportFilterOption {
  id: string
  name: string
  filter: ReportFilter
}

export interface SavedReportFilterInput {
  id?: string
  name: string
  filter: ReportFilter
}
